import React from 'react';

import { Box, Typography, Button } from '@mui/material';

import LastMonthMembershipOptionCheckbox from './LastMonthMembershipOptionCheckbox';
import { LastMonthMembershipAnnouncementCheckboxKey, LastMonthMembershipAnnouncementCheckboxState } from './types';

interface SelectionStepProps {
  checkboxes: LastMonthMembershipAnnouncementCheckboxState;
  labels: Record<LastMonthMembershipAnnouncementCheckboxKey, string>;
  handleCheckboxChange: (
    name: LastMonthMembershipAnnouncementCheckboxKey,
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleNext: () => void;
}

const SelectionStep: React.FC<SelectionStepProps> = ({ checkboxes, labels, handleCheckboxChange, handleNext }) => {
  return (
    <Box>
      <Typography sx={{ marginBottom: 2, fontWeight: 'bold', fontSize: '1.8rem', textAlign: 'center' }}>
        催促項目を指定して、メールを作成しますか？
      </Typography>
      <Box
        sx={{
          marginBottom: 3,
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 2,
          width: '60%',
          justifyContent: 'center',
          margin: '0 auto',
        }}
      >
        {Object.entries(checkboxes).map(([key, value]) => (
          <LastMonthMembershipOptionCheckbox
            key={key}
            label={labels[key as LastMonthMembershipAnnouncementCheckboxKey]}
            checked={value}
            onChange={handleCheckboxChange(key as LastMonthMembershipAnnouncementCheckboxKey)}
          />
        ))}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="contained"
          onClick={handleNext}
          sx={{
            backgroundColor: '#3b83c3',
            '&:hover': {
              backgroundColor: '#36759f',
            },
            fontWeight: 'bold',
            fontSize: '2rem',
            padding: '1rem',
            margin: '1rem auto 0',
            width: '300px',
          }}
          disabled={!Object.values(checkboxes).some((checked) => checked)}
        >
          作成
        </Button>
      </Box>
    </Box>
  );
};

export default SelectionStep;
